import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private _version = 'unknown';

  constructor() {
    this._version = this._getAppVersion().toLowerCase();
  }

  public get version(): string {
    return this._version;
  }

  private _getAppVersion(): string {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', 'assets/ver.txt', false); // Synchronous
    xhr.send();

    const raw = xhr.responseText;
    return raw.trim().replace(/^['"]|['"]$/g, '');
  }
}
